export default "__VITE_ASSET__3vd3F8b$__"